module.exports = __webpack_public_path__ + "static/media/pousada_12.692906f2.jpg";